<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">

      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item size="small" style="width:15%">
              <el-select v-model="query.datafrom" filterable placeholder="请选择数据来源" @change="changegoodstype">
              	  <el-option v-for="(item,index) in datafrom" :label="item.name" :value="item.id" :key="index" />
              </el-select>
          </el-form-item>
          <el-form-item size="small" style="width:15%">
              <el-select v-model="query.ismatch" clearable filterable placeholder="是否绑定" @change="query.ischange=true">
              	  <el-option v-for="(item,index) in matchlists" :label="item.name" :value="item.id" :key="index" />
              </el-select>
          </el-form-item>
          <el-form-item size="small" style="width:15%" v-if="query.datafrom==1">
              <el-select v-model="query.brandid" clearable filterable placeholder="请选择品牌" @change="query.ischange=true">
              	  <el-option label="不分品牌" value="0"></el-option>
              	  <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
              	  	  <span style="float: left">{{item.name}}</span>
      				  <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
              	  </el-option>
              </el-select>
          </el-form-item>
		  <el-form-item style="width:10%" v-if="query.datafrom==1">
              <el-cascader :options="categorylistsearch" v-model="query.catid" clearable placeholder="请选择分类" change-on-select @change="query.ischange=true"></el-cascader>
          </el-form-item>
          <el-form-item ref="query" :model="query" style="width:15%">
              <el-input placeholder="编号 / 名称 / 条形码 / 拼音码" v-model="query.key" clearable @keyup.enter.native="getList" @change="query.ischange=true"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
          </el-form-item>
          <el-form-item>
            <input id="fileupload" type="file" @change="importfile(this)"  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" style="display:none" title="1"/>
            <el-dropdown @command="downorupload">
                <el-button type="success" size="small" icon="el-icon-bottom">
                    导入导出关联模板<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="1">导出数据模板</el-dropdown-item>
                    <el-dropdown-item :command="2">导入匹配数据</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
      </el-form>

      <div class="backborder2" style="margin-top:10px">
          <el-table :data="goodlists" v-loading="query.loading">
              <el-table-column label="商品信息" align="left">
                <template slot-scope="scope">
                    <div style="float:left;width:100%;font-size:13px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;line-height:27px">{{scope.row.name}}</div>
                    <span style="float:left;width:100%;font-size:12px;color:#999999;line-height:27px">规格：{{scope.row.spec}}&nbsp;&nbsp;&nbsp;&nbsp;编号 / sku：{{scope.row.number}}</span>
                </template>
              </el-table-column>
              <el-table-column label="是否绑定" align="center" width="180">
                <template slot-scope="scope">
                    <div style="font-size:13px">{{scope.row.yuncode && scope.row.yuncode!='' ? '已绑定' : '未绑定'}}</div>
                </template>
              </el-table-column>
              <!--
              <el-table-column label="管易云商品id" align="center" width="180">
                <template slot-scope="scope">
                    <div style="font-size:13px">{{scope.row.yunid}}</div>
                </template>
              </el-table-column>
              -->
              <el-table-column label="管易云商品编号" align="center" width="180">
                <template slot-scope="scope">
                    <div style="font-size:13px">{{scope.row.yuncode}}</div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="120">
                <template slot-scope="scope">
                    <el-button type="warning" size="mini" icon="el-icon-edit" circle @click="getgoods(scope.row)" />
                </template>
              </el-table-column>
          </el-table>
          <div class="block">
            <!--分页begin-->
            <el-pagination
                @size-change="pageSizeChange"
                @current-change="pageCurrentChange"
                :current-page="query.p"
                :page-sizes="[10, 20, 50]"
                :page-size="query.rollpage"
                layout="total, sizes, prev, pager, next, jumper"
                :total="goodsrows">
            </el-pagination>
            <!--分页end-->
          </div>
      </div>

      <el-dialog title="设置商品编号" :visible.sync="addgoodsDialog" top="10vh" width="25%">
          <el-form :inline="true" class="demo-form-inline" size="small" v-loading="addgoodsquery.loading">
              <el-form-item ref="query" :model="query" label="关联管易云编号" label-width="140">
                  <el-input placeholder="编号 / 名称 / 条形码 / 拼音码" v-model="addgoodsquery.code" clearable />
              </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="savegoodscode">保 存</el-button>
          </div>
      </el-dialog>


  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Kingdeecloud/index",
      transitionshow:true,
      actionauth:'',
      isnewselect:false,
      datafrom:[{id:1,name:'宠赞'},{id:2,name:'京东'}],
      matchlists:[{id:1,name:'已绑定'},{id:2,name:'未绑定'}],
      brandlists:[],
      categorylistsearch:[],
      query:{
        act:'getczgoods',
        token:this.$cookies.get('token'),
        ismatch:'',
        datafrom:1,
        brandid:'',
        catid:'',
        loading:false,
        ischange:false,
        key:'',
        rollpage: 10, // 页大小
        p: 1
      },
      goodlists:[],
      goodsrows:0,
      addgoodsDialog:false,
      addgoodsquery: {
          act:'matchgoods',
          token:this.$cookies.get('token'),
          loading:false,
          goodsid:'',
          type:'',
          code:''
      },


    }
  },

  mounted(){  
  	this.getactionauth(); //获取权限设置
      this.getBrand(); //获取品牌列表
      this.getCategoryList(); //获取商品分类列表
      this.getList(); //获取商品列表
  },

  methods: {


    /** 上传或下载匹配数据 **/
    downorupload(type) {
        if(type==1) this.getdownmodel();
        if(type==2) this.uploadmodel();
    },   


    /** 下载模板数据 **/
    getdownmodel() {
        var url=this.GLOBAL.exportUrl+"Kingdeecloud/index/act/downgoodsupload/token/"+this.$cookies.get('token');
        location.href=url;
    },

    /** 上传模板数据 **/
    uploadmodel() {
        document.getElementById("fileupload").click();
    },

    /************** 导入excel表格数据 **************/
    importfile(obj) {    
    	let _this = this;
        let inputDOM = this.$refs.inputer;
        // 通过DOM取文件数据
        this.file = event.currentTarget.files[0];                
        var rABS = false; //是否将文件读取为二进制字符串
        var f = this.file;
        var outdata;
        var reader = new FileReader();
        FileReader.prototype.readAsBinaryString = function(f) {
        	var binary = "";
            var rABS = false; //是否将文件读取为二进制字符串
            var pt = this;
            var wb; //读取完成的数据
            var reader = new FileReader();
            reader.onload = function(e) {
            	var bytes = new Uint8Array(reader.result);
                var length = bytes.byteLength;
                for(var i = 0; i < length; i++) binary += String.fromCharCode(bytes[i]);
                var XLSX = require('xlsx');
                if(rABS) {
                	wb = XLSX.read(btoa(fixdata(binary)), {type:'base64'});
                }else {
                    wb = XLSX.read(binary, {type: 'binary'});
                }
                outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);//outdata就是你想要的东西
                //清空输入框的文件值，避免下次change事件失效
                document.getElementById('fileupload').value = null;

                if(outdata.length > 500) {_this.$message.error('请一次上传数据不要超过500条');return false;}

                var loading=_this.$loading({
					lock: true,
					text: '数据玩命上传中，请稍后...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.8)'
				});	
                
                //提交数据到后台
        		var resource = _this.$resource(_this.url);
                resource.save({act:'inputgoodsmatch',infos:outdata,token:_this.$cookies.get('token')}).then((res) => {
                    if(res.data.Result>0){
                    	if(res.data.Result=='70001') this.$router.push('/login')
                    	_this.$message({
				    		dangerouslyUseHTMLString: true,
				    		type:'error',
				    		message:'<span style="line-height:20px">'+res.data.Message+'</span>',
			    		});
                        loading.close();
                    }else{
                    	_this.getList();
                    	_this.$message.success('导入商品信息成功!');
                        loading.close();
                  	}
                }).catch((res) => {
                    _this.$message.error(this.GLOBAL.errortext);
                    loading.close();
                });        
                           
            }
            reader.readAsArrayBuffer(f);
        }
               
        if(rABS) {
        	reader.readAsArrayBuffer(f);
        } else {
            reader.readAsBinaryString(f);
        }                 
    },
    /************************** 导入excel表格数据 ****************************************/





    /** 获取商品匹配明细 **/
    getgoods(item) {
        this.addgoodsDialog=true;
        this.addgoodsquery.goodsid=item.id;
        this.addgoodsquery.type=item.type;
        this.addgoodsquery.number=item.number;
        this.addgoodsquery.code=item.number;

        this.addgoodsquery.loading = true;
        var resource = this.$resource(this.url);
        resource.save({act:'getgoodsinfo',token:this.$cookies.get('token'),goodsid:this.addgoodsquery.goodsid,type:this.addgoodsquery.type}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.addgoodsquery.loading = false;
	        }else{
                var result = JSON.parse(Base64.decode(res.data.Data));
                result.code ? this.addgoodsquery.code=result.code : '';
	            this.addgoodsquery.loading = false;	            		
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.addgoodsquery.loading = false;	  
        });
    },

    /** 保存商品匹配信息 **/
    savegoodscode() {
        var resource = this.$resource(this.url);
        resource.save(this.addgoodsquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
                this.addgoodsDialog=false;
                this.getList();      		
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);  
        });
    },


    /** 获取商品信息列表 **/
    getList() {
        if(this.query.ischange=true) {
            this.query.p=1;
            this.query.rollpage=10;
        }

        this.query.loading = true;
        var resource = this.$resource(this.url);
        resource.save(this.query).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.query.loading = false;
	        }else{
	            this.goodlists = JSON.parse(Base64.decode(res.data.Data));
	            this.goodsrows=parseInt(res.data.count);
	            this.query.loading = false;	            		
	        }
	        if(this.query.ischange==true) this.query.ischange=false;
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.query.loading = false;	  
        });
    },
    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },

    /** 修改商品类型 **/
    changegoodstype() {
        this.query.ischange=true;
        this.query.brandid='';
        this.query.catid='';
        this.query.key='';
        this.query.datafrom==1 ? this.query.act='getczgoods' : this.query.act='getjdgoods';
        this.getList();
    },



    /** 获取操作功能权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },

    /** 获取品牌 **/
    getBrand(){
        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
        resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	        	var _this=this;
	        	var thumb='';
	            this.brandlists = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    /** 获取分类列表 **/
    getCategoryList(){
        var resource = this.$resource(this.GLOBAL.domain+"Product/index");
        resource.query({ act:'getcatelist',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.categorylistsearch = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
    },




  },

}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/kingdeeyun/Yungoods.vue